/* eslint-disable @typescript-eslint/no-explicit-any */
import DataStore from './DataStore';
import { DEFAULT_SETTINGS } from './shared/constants/Constants';

import {
  Account,
  AccountWithSummary,
  LinkedAccounts,
  Settings,
} from '../types/shared/Account';
import IndexedList from './shared/IndexedList';

let dataStore = DataStore.getInstance('app');

let AccountActions = {
  addAccount(newAccount: AccountWithSummary) {
    let accounts = dataStore.get('accounts') || new IndexedList([]);
    let newAccounts = accounts.push(newAccount);
    dataStore.set('accounts', newAccounts);
    return newAccounts;
  },

  updateAccountByID(id: string, updates: Partial<Account>) {
    let accounts = dataStore.get('accounts');
    if (accounts) {
      let oldAccount = accounts.getByID(id);
      let newAccounts = accounts.setByID(id, {
        ...oldAccount,
        ...updates,
      } as any);
      dataStore.set('accounts', newAccounts);
    }
  },

  updateAccount(updates: Partial<Account>) {
    let oldAccount = dataStore.get('account');
    if (!oldAccount) {
      throw new Error(t('Unable to update account; Not logged in.'));
    }
    let newAccount = {
      ...oldAccount,
      ...updates,
    };
    dataStore.set('account', newAccount);
    return newAccount;
  },

  updateSettings(updates: Partial<Settings>) {
    let oldAccount = dataStore.get('account');
    if (!oldAccount) {
      return;
    }
    let oldSettings: Settings = oldAccount.settings || DEFAULT_SETTINGS;
    let newSettings = {
      ...oldSettings,
      ...updates,
    };
    return AccountActions.updateAccount({
      settings: newSettings,
    });
  },

  updateLinkedAccounts(updates: Partial<LinkedAccounts>) {
    let oldAccount = dataStore.get('account');
    if (!oldAccount) {
      return;
    }
    let oldLinkedAccounts: LinkedAccounts = oldAccount.linked_accounts || {};
    let newLinkedAccounts = {
      ...oldLinkedAccounts,
      ...updates,
    };
    return AccountActions.updateAccount({
      linked_accounts: newLinkedAccounts,
    });
  },

  deleteAccountByID(id: string) {
    let accounts = dataStore.get('accounts');
    if (accounts) {
      let index = accounts.getIndexByID(id);
      if (index !== -1) {
        let newAccounts = accounts.splice(index, 1);
        dataStore.set('accounts', newAccounts);
      }
    }
  },
};

export default AccountActions;
